<template>
  <div style="position: relative">
    <v-row no-gutters>
      <v-col v-if="sectionList.length > 0" class="pa-0" cols="12">
        <v-tabs
          v-if="sectionList.length > 1 && !isInIframe"
          dark
          :style="computedWindowWidth"
          :height="$vuetify.breakpoint.width < 960 ? 35 : 35"
          v-model="selectedTab"
          show-arrows
        >
          <v-tab
            v-for="(item, index) in sectionList"
            :key="index"
            :style="{ 'z-index': 100 - index }"
            :tabindex="index"
            :ripple="false"
            @click="selectSection(index)"
            :class="item.stTitle ? 'tab pt-2' : 'tab v-tab-untitled pt-2'"
          >
            <v-menu :close-on-content-click="false" bottom offset-y>
              <template v-slot:activator="{ on }">
                <div class="px-1" style="display: inline-block">
                  <div style="display: inline-block">
                    <v-avatar
                      v-if="item.stUploaderInfo"
                      :color="item.stUploaderInfo.userDisplayName || item.stUploaderInfo.userFullName | iconBackground"
                      class="logo"
                      round
                      size="20"
                      style="cursor: default; margin-top: -12px"
                    >
                      <div class="avatar-bg" v-if="item.stUploaderInfo.userPicture"></div>
                      <span class="v-avatar-name-tab" v-if="!item.stUploaderInfo.userPicture">
                        {{ item.stUploaderInfo.userDisplayName || item.stUploaderInfo.userFullName | iconFilter }}
                      </span>
                      <v-img class="v-avatar-name-tab" :src="item.stUploaderInfo.userPicture" v-else />
                    </v-avatar>
                  </div>

                  <v-tooltip top :color="!isMobile ? '#131b1e' : 'transparent'">
                    <template v-slot:activator="{ on }">
                      <div
                        class="ml-3 mr-2 text-truncate"
                        style="display: inline-block; max-width: 150px; margin-bottom: 1px"
                        v-on="on"
                      >
                        {{ item.stTitle ? item.stTitle : 'Untitled' }}
                      </div>
                    </template>
                    <span v-if="!isMobile">{{ item.stTitle ? item.stTitle : 'Untitled' }}</span>
                  </v-tooltip>

                  <v-icon
                    v-if="selectedTab == index && (isMtOrganizer || isSectionOrganizer(index))"
                    size="18"
                    class="pointer tab-menu"
                    style="margin-top: -12px"
                    v-on="on"
                  >
                    mdi-dots-horizontal
                  </v-icon>
                </div>
              </template>
              <div class="pa-2" style="width: 100%">
                <v-text-field
                  :ref="'sectiontitle'"
                  v-model="item.stTitle"
                  class="txtf-section-title"
                  hide-details
                  @blur="updateStInfo(index)"
                  @keyup.enter="updateStInfo(index)"
                  flat
                  solo
                  autofocus
                  dense
                  label="Untitled"
                  dark
                  background-color="#0F2129"
                  :placeholder="$t('unTitledSection')"
                  style="display: inline-block; width: 200px"
                ></v-text-field>
                <div class="btn-delete" style="display: inline-block; width: auto; vertical-align: top">
                  <section-delete-dialog
                    :sectionInfo.sync="sectionList[index]"
                    :userInfo.sync="userInfo"
                  ></section-delete-dialog>
                </div>
              </div>
            </v-menu>
          </v-tab>
          <v-tooltip top color="#131b1e">
            <template v-slot:activator="{ on }">
              <v-btn
                class="btn-add-section"
                :loading="isAddLoading"
                color="transparent"
                @click="addNewSection"
                elevation="0"
                plain
                v-on="on"
              >
                <v-icon color="#25C685" class="pointer icon-add-section">mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>Add new section</span>
          </v-tooltip>
        </v-tabs>
        <v-tabs-items
          v-model="selectedTab"
          touchless
          :style="
            isInIframe ? 'overflow: auto' : $vuetify.breakpoint.width < 1263 ? 'overflow: auto' : 'overflow: auto'
          "
        >
          <v-tab-item v-for="(data, i) in sectionList" :key="data.stId">
            <!-- Section Video -->
            <detail-video
              :class="`video-component-${i}`"
              :sectionInfo="data"
              :isLoaded.sync="isLoaded"
              :sectionIndex="i"
              :upHere.sync="upHere"
              @refreshData="refreshData"
              upHerexc
            ></detail-video>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
      <!-- Empty 화면 -->
      <v-col v-else-if="mtInfo.mtType !== 'topic'" class="flex-shrink-1" cols="12" xl="auto" lg="auto" md="12" sm="12">
        <detail-video :isLoaded.sync="isLoaded"></detail-video>
      </v-col>
    </v-row>
    <!-- <due-date-dialog
      v-if="dateVisible"
      :isFollowUp="false"
      :dateVisible.sync="dateVisible"
      @close="dateVisible = false"
      @finish="finishDateDialog"
    ></due-date-dialog> -->
    <share-dialog v-if="isShareDialog" @close="closeDialog" :isShareDialog.sync="isShareDialog"></share-dialog>
    <guest-in v-if="guestInVisible" @close="closeGuestIn" :guestInVisible.sync="guestInVisible"></guest-in>
  </div>
</template>

<script>
import SectionDeleteDialog from '@/views/modal/SectionDeleteDialog'
import DetailVideo from '@/views/meeting/component/detail/DetailVideo'
import { mapState, mapGetters } from 'vuex'
// import DetailComment from '@/views/meeting/component/detail/DetailComment'
import { setCreateSection } from '@/services/sectionApi'
// import DueDateDialog from '@/views/modal/DueDateDialog'
import ShareDialog from '@/views/modal/ShareDialog'
import Toast from '@/views/meeting/component/Toast'
import { isMobile } from '@/common/lib/strLib'
import { setUpdateSection } from '@/services/sectionApi'
import GuestIn from '@/views/modal/GuestIn'

export default {
  props: ['isLoaded', 'upHere'],
  components: {
    DetailVideo,
    // DetailComment,
    ShareDialog,
    // DueDateDialog,
    SectionDeleteDialog,
    GuestIn,
  },
  data() {
    return {
      isAddLoading: false,
      sortItem: this.$store.getters.clipSort,
      sortItems: ['Latest', 'Oldest'],
      menuData: {
        menuIcon: 'mdi-dots-horizontal',
        iconColor: '#c4c4c4',
        bgColor: '#21343b',
      },
      menuItems: [
        { title: this.$t('willFollowUp'), type: 'willFollowUp' },
        { title: this.$t('requestResponse'), type: 'requestResponse' },
      ],
      selectedTab: this.$store.getters.sectionIndex ? this.$store.getters.sectionIndex : 0,
      isShareDialog: false,
      guestInVisible: false,
    }
  },
  mounted() {
    // window.addEventListener('beforeunload', this.scrollTotheTop)

    this.setSectionScroll()
    this.scrollTotheTop()
  },
  beforeDestroy() {
    // window.removeEventListener('beforeunload', this.scrollTotheTop)
  },

  methods: {
    scrollTotheTop() {
      if (window.innerWidth <= 1263) {
        setTimeout(() => {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
          })
        }, 10)
      }
    },

    closeGuestIn() {
      this.guestInVisible = false
      if (this.userInfo) this.addNewSection()
    },
    selectSection(index) {
      this.$store.dispatch('setSectionIndex', index)
      this.$store.dispatch('setClipIndex', 0)
      // let sectionList = this.$store.getters.totalSectionList

      if (this.sectionList && this.sectionList !== null && this.sectionList.length > index) {
        if (this.sectionList[index] && this.sectionList[index]) {
          let playList = this.sectionList[index].clipList
          if (playList && playList !== null && playList.length > 0) this.$store.dispatch('setCurrentClip', playList[0])
        }
      }
    },
    async updateStInfo(index) {
      try {
        await setUpdateSection(
          this,
          this.sectionList[index].stId,
          this.sectionList[index].mtId,
          this.sectionList[index].stTitle
        )
      } catch (error) {
        console.log(error)
      }
    },
    setWillFollowUp() {
      if (this.followUpExsitContents !== undefined && this.followUpExsitContents !== null) {
        // notify(this, 'Error', this.followUpExsitContents, 'error')

        const content = {
          component: Toast,
          props: {
            msg: this.followUpExsitContents,
            // submsg: '',
          },
        }
        this.$toast.error(content)
      } else {
        if (this.mtInfo.isEnded) {
          // notify(this, 'Error', this.$t('notiEndedMeeting'), 'error')

          const content = {
            component: Toast,
            props: {
              msg: this.$t('notiEndedMeeting'),
              // submsg: '',
            },
          }
          this.$toast.error(content)
        }
        // else this.dateVisible = true
      }
    },
    openDialog(type) {
      if (type === 'Share') {
        this.isShareDialog = true
      }
      this.$emit('openDialog')
    },
    closeDialog(val) {
      if (val && val.type === 'Attendee') {
        this.attendeeVisible = false
        this.mtInfo.mtAttendeeList = val.list
      } else if (val === 'Share') {
        this.isShareDialog = false
      } else if (val === 'MoveToMeeting') {
        this.isMoveToDialog = false
      }
    },
    refreshData() {
      this.$emit('refreshData')
    },
    async addNewSection() {
      if (this.isSectionMt && this.userInfo && !this.mtInfo.isEnded) {
        try {
          this.isAddLoading = true
          let result = await setCreateSection(this, this.mtInfo.mtId, 'default', '', Date.now(), this.userInfo.userId)
          // let totalSectionList = this.totalSectionList
          // totalSectionList.push(result)
          // this.$store.dispatch('setTotalSectionList', totalSectionList)
          // await this.$store.dispatch('setSectionIndex', this.sectionList.length)
          await this.$store.dispatch('setAddSection', result)
          // if (!isMobile() && window.location.href.search('clipId') === -1 && !localStorage.getItem('stId')) {
          //   this.$nextTick(() => {
          //     setTimeout(() => {
          //       this.$refs.sectiontitle ?? this.$refs.sectiontitle.$refs.input.focus(), 0
          //     })
          //   })
          // }
        } catch (error) {
          console.log(error)
        } finally {
          this.isAddLoading = false
          // this.selectedTab = this.sectionIndex
        }
      } else if (this.mtInfo.isEnded) {
        // notify(this, 'This meeting has ended.', '', 'message')

        const content = {
          component: Toast,
          props: {
            msg: 'This meeting has ended.',
            // submsg: '',
          },
        }
        this.$toast(content)
      } else if (!this.userInfo) {
        this.guestInVisible = true
      }
    },
    setSectionScroll() {
      setTimeout(() => {
        try {
          let className = 'video-component-' + this.sectionIndex
          let currentItem = document.getElementsByClassName(className)
          let sectionScrollY = 0
          let sectionScrollX = 0

          if (currentItem && currentItem !== null && currentItem.length > 0) {
            sectionScrollY = currentItem[0].offsetTop
            sectionScrollX = currentItem[0].offsetLeft

            let listHeight = window.outerHeight / 2 - currentItem[0].offsetHeight / 2
            let listWidth = window.outerWidth / 2 - currentItem[0].offsetWidth / 2

            sectionScrollY -= listHeight / 2
            sectionScrollX -= listWidth / 2
          }

          localStorage.setItem('sectionScrollX', sectionScrollX)
          localStorage.setItem('sectionScrollY', sectionScrollY)
          if (this.mtInfo.mtClipCount === 0 && !this.mtInfo.mtTopic) return // 미팅제목과 클립이 동시에 없으면 상단 고정

          window.scrollTo({
            top: sectionScrollY,
            left: sectionScrollX,
            behavior: 'smooth',
          })
        } catch (e) {
          console.log('Error : ', e)
        }
      }, 1)
    },
    isSectionOrganizer(index) {
      return (
        this.sectionList !== undefined &&
        this.sectionList !== null &&
        this.userInfo !== undefined &&
        this.userInfo !== null &&
        this.sectionList[index].stCreatorUid === this.userInfo.userId
      )
    },
  },
  computed: {
    ...mapGetters([
      'userInfo',
      // 'selectedWsInfo',
      // 'selectedCh',
      'currentMt',
      // 'addSection',
      // 'deleteSection',
      // 'clipSort',
      // 'uploadClip',
      // 'currentClip',
      'totalSectionList',
      'clipIndex',
      'isRequestSetSeekTime',
      'sectionIndex',
    ]),
    isMobile() {
      return isMobile()
    },
    mtInfo() {
      return this.currentMt ?? {}
    },
    sectionList() {
      if (this.totalSectionList !== undefined && this.totalSectionList !== null && this.totalSectionList.length > 0) {
        return this.totalSectionList
      }
      return []
    },
    ...mapState({
      isMtOrganizer: (state) => {
        if (
          state &&
          state !== null &&
          state.auth &&
          state.auth !== null &&
          state.auth.currentMt &&
          state.auth.currentMt !== null &&
          state.auth.userInfo &&
          state.auth.userInfo !== null
        ) {
          return state.auth.currentMt.mtOrganizerUid === state.auth.userInfo.userId
        } else {
          return false
        }
      },
    }),
    spaceViewPort() {
      return this.mtInfo.mtType === 'topic' ? '12' : 'auto'
    },
    commentViewPort() {
      return this.mtInfo.mtType === 'topic' ? '12' : 'auto'
    },
    sectionViewPort() {
      return this.mtInfo.mtType === 'topic' ? '12' : ''
    },
    isSectionMt() {
      return this.mtInfo.mtType === 'topic'
    },
    followUpExsitContents() {
      if (this.sectionList.length > 0) {
        let section = this.sectionList.find(
          (data) =>
            data.followUpItem !== undefined &&
            data.followUpItem !== null &&
            (data.followUpItem.clipType === 'followUp' || data.followUpItem.clipType === 'willFollowUp')
        )
        if (
          section !== undefined &&
          section !== null &&
          section.followUpItem !== undefined &&
          section.followUpItem !== null
        ) {
          return (
            (section.followUpItem.clipUploader.userDisplayName || section.followUpItem.clipUploader.userFullName) +
            this.$t('followUpAlreadyExsit')
          )
        } else null
      }
      return null
    },
    isInIframe() {
      return window.location != window.parent.location
      // return true
    },
    computedWindowWidth() {
      let width = window.innerWidth
      let style = 'width :'
      return style + width + 'px'
    },
  },
  watch: {
    clipIndex() {
      this.setSectionScroll()
    },
    sectionIndex(val) {
      this.setSectionScroll()
      this.selectedTab = val
    },
    sortItem(val) {
      this.$store.dispatch('setClipSort', val)
      this.$emit('refreshData')
    },
    // isRequestSetSeekTime(isRequestSetSeekTime) {
    //   if (isRequestSetSeekTime && isRequestSetSeekTime !== null) this.setSectionScroll()
    // },
    currentMt: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val && this.currentMt.mtTopic !== '') {
          document.title = this.currentMt.mtTopic
        } else {
          document.title = 'Tape - AI-Powered Recording, Transcription, and Summarization'
        }
      },
    },
  },
}
</script>

<style scoped>
.v-tabs >>> .v-tabs-bar {
  position: relative;
  background-color: transparent !important;
}
.v-tabs >>> .v-tab {
  border-radius: 5px 5px 0 0;
  background-color: #2b3f46;
  box-shadow: 1px 0px 0px #1a272e;
  /* margin-top: 16px;
  margin-right: -5px; */
  height: 35px;
  text-transform: none !important;
  letter-spacing: 0;
  font-size: 14px;
  font-weight: 400;
  color: #96a7af !important;
}
.v-tabs >>> .v-tab::before {
  display: none;
}
.v-tabs >>> .v-tab--active {
  color: #fff !important;
  background-color: rgb(29, 41, 47) !important;
  z-index: 101 !important;
}
.v-tabs >>> .v-tab--active {
  cursor: default;
}
.v-tabs >>> .v-tab--active::before {
  display: none;
}
.v-tab-untitled {
  color: #888 !important;
}
.tab-menu {
  color: #96a7af !important;
  transition: all 0.3s;
}
.tab-menu:hover {
  color: #fff !important;
  transition: all 0.3s;
}
.v-window {
  background-color: transparent;
  /* border-radius: 30px; */
  overflow: hidden !important;
}
.v-avatar-name-tab {
  color: #ffffff;
  font-size: 11px;
  font-weight: 800;
  text-align: center;
  margin-left: 0px;
  position: relative;
  /* top: 0.5px; */
}
.avatar-bg {
  content: '';
  position: absolute;
  border-radius: 50%;
  top: 0px;
  left: 0px;
  width: calc(100%) !important;
  height: calc(100%) !important;
  background-color: white;
  z-index: 0;
}
.btn-add-section {
  min-width: 36px !important;
  margin-top: -1px;
  margin-left: -1px;
}
.icon-add-section:hover {
  animation-name: rotate;
  animation-duration: 2s;
  animation-delay: 0s;
  animation-iteration-count: infinite;
}
.v-tabs >>> .v-tabs-slider-wrapper {
  height: 0 !important;
}
@keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  90% {
    -webkit-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    transform: rotate(180deg);
  }
  100% {
    -webkit-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    transform: rotate(180deg);
  }
}
@media screen and (max-width: 959px) and (orientation: portrait) {
  .v-tabs {
    position: fixed;
    top: 55px;
    left: 0;
    z-index: 2;
  }
}

@media screen and (max-width: 959px) and (orientation: landscape) {
  .v-tabs {
    position: relative;
    top: unset;
  }
}
@media (max-width: 959px) {
  .v-tabs >>> .v-tabs-bar {
    margin: 0;
  }
  .v-tabs >>> .v-tab {
    height: 35px;
    box-shadow: none;
    border-radius: 0;
    font-size: 13px;
    font-weight: 500;
  }
  .v-tabs >>> .v-tab--active {
    font-size: 13px;
    background-color: #1f2e35 !important;
    z-index: 101 !important;
  }
  .v-window {
    background-color: #1a272e !important;
    border-radius: 0px;
  }
  .v-tabs >>> .v-slide-group__prev,
  .v-tabs >>> .v-slide-group__next {
    background-color: #2b3f46 !important;
  }
  .v-tabs >>> .v-slide-group__prev {
    border-right: 1px solid #1a272e;
  }
  .v-tabs >>> .v-slide-group__next {
    border-left: 1px solid #1a272e;
  }
}
.container-btn >>> .v-btn * {
  font-size: 13px;
  color: #27cd8b;
  letter-spacing: 0;
  text-transform: none;
  font-weight: bold;
}

.divider {
  background-color: #63737d;
}

.txt-sort-title {
  color: white;
  font-weight: bold;
  font-size: 18px;
}
.v-select >>> .v-input__slot {
  background: #1a272e !important;
}
.v-select >>> .v-select__selection {
  color: #27cd8b !important;
  font-weight: 500;
  font-size: 18px;
  text-overflow: ellipsis;
}

.v-select >>> .v-select__slot input {
  color: #27cd8b !important;
  font-weight: 500;
  font-size: 18px;
  text-overflow: ellipsis;
}
.v-select >>> .v-select__slot i {
  color: #27cd8b !important;
}
.v-input {
  width: 120px;
}
.chronological-container-comment {
  max-width: 420px;
}
.menu-txt-class {
  color: white;
  font-size: 14px;
}
.icon-more {
  color: white;
  font-size: 14px;
  font-size: 30px;
  margin-right: 0px !important;
}
.v-tooltip {
  z-index: 200;
}
.v-tooltip__content {
  font-size: 12px !important;
  opacity: 1;
}
@media (max-width: 1263px) {
  .chronological-container-comment {
    max-width: 100%;
  }
}
.btn-side-section >>> .v-btn__content {
  display: block;
}
@media (max-width: 959px) {
  div.v-tabs.theme--dark.fixed {
    position: fixed;
    top: 55px;
    z-index: 199;
  }
}
</style>
